import { useState, useEffect, useContext } from 'react'
import Stack from 'react-bootstrap/Stack'

import { getOrgEventsForReport, getTicketScanReport } from '../../utilities/api'
import { useReportRefresh } from '../../hooks/useReportRefresh'

import LoadingContext from '../../context/Loading/Loading'

import { EventSelector } from '../EventSelector'
import { PageLoadingContainer } from '../PageLoadingContainer'
import { EmptyContainer } from '../EmptyContainer'
import { ReportRefreshButton } from '../ReportRefreshButton'

import Card from 'react-bootstrap/Card'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'

import TimeSeriesChart from './TimeSeriesChart'
import HeatmapChart from './HeatmapChart'

export default function ScanChartWrapper({ organization }) {
  const { isLoading, showLoading, hideLoading } = useContext(LoadingContext)
  const [events, setEvents] = useState()
  const [tickets, setTickets] = useState()
  const [selectedEventUUID, setSelectedEventUUID] = useState()
  const [isLoadingData, setIsLoadingData] = useState(false)
  const { refreshToken, refresh, completeRefresh } =
    useReportRefresh(isLoadingData)

  const [key, setKey] = useState('Time')

  const handleKey = (k) => {
    setKey(k)
  }

  useEffect(() => {
    showLoading()
    loadEvents(organization.uuid)
  }, [])

  const loadEvents = async (organizationUUID) => {
    let res = await getOrgEventsForReport(organizationUUID)

    if (res.status === 200) {
      setEvents(res.data)
      hideLoading()
    }
  }

  useEffect(() => {
    if (!selectedEventUUID) return

    setIsLoadingData(true)
    getTicketScanReport(selectedEventUUID)
      .then((res) => {
        const scannedTickets = res.data.filter(
          (ticket) => ticket.scanned_in_time
        )
        setTickets(scannedTickets)
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setIsLoadingData(false)
        completeRefresh()
      })
  }, [selectedEventUUID, refreshToken])

  return (
    <>
      {isLoading ? (
        <PageLoadingContainer style="without-sidebar" />
      ) : (
        <section className="spacer-sm" id="analytics-wrapper">
          <header className="section-header-sm report-page-header">
            <div className="section-heading">
              <h1>Scan Summary</h1>
            </div>
            <p className="section-header-desc">
              View ticket scanning data for the selected event.
            </p>
          </header>
          {events?.length > 0 ? (
            <>
              <Stack
                direction="horizontal"
                gap={3}
                className="mb-4 align-items-end flex-wrap"
              >
                <EventSelector
                  setSelected={setSelectedEventUUID}
                  selected={selectedEventUUID}
                  events={events}
                  isLoading={isLoadingData}
                />
                <ReportRefreshButton
                  onRefresh={refresh}
                  isRefreshing={isLoadingData}
                  disabled={!selectedEventUUID || isLoadingData}
                />
              </Stack>
              {tickets?.length > 0 ? (
                <Tabs
                  defaultActiveKey="Time"
                  activeKey={key}
                  onSelect={handleKey}
                  variant="pills"
                  className="w-max-content nav-pills-default mt-4"
                >
                  <Tab eventKey="Time" title="Scans per minute">
                    <Card body className="mt-4">
                      <TimeSeriesChart tickets={tickets} />
                    </Card>
                  </Tab>
                  <Tab eventKey="Heatmap" title="Heatmap of Scans">
                    <Card body className="mt-4">
                      <HeatmapChart tickets={tickets} />
                    </Card>
                  </Tab>
                </Tabs>
              ) : (
                <Card body>
                  <EmptyContainer style="center lg">
                    <p>No scan data</p>
                    <p className="subtitle">
                      There's currently no scan data for this event.
                    </p>
                  </EmptyContainer>
                </Card>
              )}
            </>
          ) : (
            <Card body>
              <EmptyContainer style="center lg">
                <p>No events created</p>
                <p className="subtitle">
                  Create an event to start tracking its scans.
                </p>
              </EmptyContainer>
            </Card>
          )}
        </section>
      )}
    </>
  )
}
